import React, {useState,useEffect} from 'react'
import Movielist from './Movielist'
import { useGlobalContext } from '../context';


const Home = () => {
    const {movies} = useGlobalContext()
    return (
        <>
            <div className="movie_main">
                <div className="movie_container">
                    {movies.map((movie)=>{
                        return <Movielist key={movie.id} {...movie} />
                    })}
                </div>
            </div>
        </>
    )
}

export default Home
